/**
 * A hidden button component that receives initial focus to prevent auto-focus
 * on other elements (like inputs) when modals or dialogs open.
 *
 * Usage: Place this as the first focusable element in your modal/dialog
 * to prevent Radix UI from auto-focusing inputs with text selection.
 */
export const FocusRemover = () => (
	<button
		type="button"
		style={{ position: 'absolute', left: '-9999px', opacity: 0 }}
		tabIndex={0}
		aria-hidden="true"
	>
		Hidden focus trap
	</button>
)
